import * as React from 'react'
import { browserHistory } from 'react-router'
import { inject, observer } from 'mobx-react'
import { ICategoryContract, CreateBaseCategory, CreateCategory } from '@getgreenline/homi-shared'
import { InputWithCloseIcon } from '../../../../components/Input/InputWithCloseIcon'

interface Props {
  category: CreateCategory
  childCategoryIndex: number
}

@observer
export class ChildCategory extends React.Component<Props, {}> {
  render() {
    const category = this.props.category
    const childCategory = category.childCategories[this.props.childCategoryIndex]

    if (!childCategory) {
      return <div />
    }

    return (
      <InputWithCloseIcon
        value={childCategory.name}
        onChange={(newValue) => (childCategory.name = newValue)}
        onRemove={() => category.childCategories.splice(this.props.childCategoryIndex, 1)}
      />
    )
  }
}
